import React from 'react';
import { type Person } from 'talent_matching/types';
import { useTalentMatchingTabContext } from 'talent_matching/contexts/talent_matching_tab_context';
import { useCompanyInfoContext } from 'shared/components/company_info/company_info_context';
import { usePrefetchCompanyProfiles } from 'shared/components/company_info/use_company_profiles';
import BaseResumeDetailsCell from 'talent_matching/components/shared/base_resume_details_cell';

type Props = {
  candidate: Person;
};

const ResumeDetailsCell = ({ candidate }: Props) => {
  const { setActiveSidePanelTab } = useTalentMatchingTabContext();
  const { canViewCompanyInfo } = useCompanyInfoContext();
  const prefetchCompanyProfiles = usePrefetchCompanyProfiles();

  const resume = candidate.resume;
  const employments = resume?.details?.employments || [];

  return (
    <BaseResumeDetailsCell
      employments={employments}
      parsingStatus={resume?.parsing_status}
      resumeExists={!!resume}
      onShowMore={() => setActiveSidePanelTab('resume')}
      showCompanyInfo={canViewCompanyInfo}
      onCompaniesHovered={prefetchCompanyProfiles}
    />
  );
};

export default ResumeDetailsCell;
